import React from "react";
import StyledImage from "../../../shared/StyledImage";
import { Notebook } from "../../normalizer";
import CustomButton from "../../shared/CustomButton";

const NewsCard = (props) => {
  const { title, subtitle, id, image } = props;
  const sizeKey = "square_thumbnail_image";
  const croppedKey = sizeKey.replace("image", "cropped_image");
  const imageUrl =
    (image[croppedKey] && image[croppedKey].url) ||
    (image[sizeKey] && image[sizeKey].url) ||
    (image.mobile_image && image.mobile_image.url) ||
    "";

  return (
    <div className="news-card">
      {imageUrl && <StyledImage url={imageUrl} className="news-card-image" />}
      <div className="news-card-content">
        <div className="news-card-content-date"></div>
        <div className="news-card-content-title">{title}</div>
        <div className="news-card-content-subtitle">{subtitle}</div>
        <div className="news-card-content-link">
          <CustomButton small link tight to={`/news/${id}`}>
            Saiba mais
          </CustomButton>
        </div>
      </div>
    </div>
  );
};
export default NewsCard;
